/* unplugin-vue-components disabled */import script from "./CategoryNav.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryNav.vue?vue&type=script&setup=true&lang=js"

import "./CategoryNav.vue?vue&type=style&index=0&id=5e365592&lang=scss&scoped=true"
import "./CategoryNav.vue?vue&type=style&index=1&id=5e365592&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e365592"]])

export default __exports__